<template>
  <div>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Update Shipping By Key or Document Number
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Agent"
										solo
										hide-details
										disabled
                    :loading="loading"
										v-model="userName"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-text-field
										label="Delimiter"
										solo
										disabled
										hide-details
                    :loading="loading"
										v-model="delimiter"
									></v-text-field>
              	</v-flex>
								<v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys & Document Numbers & Customer Id"
										v-model="pastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  {{[...dArray, ...mArray, ...oArray].length}} / {{totalK}}
                </v-flex>
                <v-flex xs12>
									<v-layout row wrap>
                    <v-flex xs4>
                      <div style="font-weight:bold;">Updated</div>
                      <v-layout row wrap>
                        <v-flex xs12 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in dArray" :key="k+ '-Done'">{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <div style="font-weight:bold;">Migrated then Updated</div>
                      <v-layout row wrap>
                        <v-flex xs12 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in mArray" :key="k+ '-Migrated'">{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <div style="font-weight:bold;">Already Done</div>
                      <v-layout row wrap>
                        <v-flex xs12 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in oArray" :key="k+ '-Already'"
                            v-clipboard:copy="k"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <div style="font-weight:bold;">Not Found / Wrong Key</div>
                      <v-layout row wrap>
                        <v-flex xs12 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                          <div v-for="k in eArray" :key="k+ '-Error'"
                            v-clipboard:copy="k"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >{{k}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
								</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-btn color="primary" @click="updateKeysWithDocN()">update keys with doc number & migrate</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Update Shipping By Key or Document Number
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys OR Document Numbers"
										v-model="spastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs12 class="text-xs-center" pb-5>
                  <v-btn color="primary" @click="searchByKey()">fetch leads by key</v-btn>
                  <v-btn color="primary" @click="searchByDoc()">fetch leads by document</v-btn>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  {{leads.length}} / {{totalW}}
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Leads
                </v-flex>
                <v-flex xs12 class="text-xs-center" pb-5>
                  <v-btn color="primary" @click="exporLeadsByKey()">export leads</v-btn>
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap v-if="leads && leads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in leads" :key="l+'-lead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Not found keys
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(nKeys)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="nKeys && nKeys.length">
                    <v-flex xs12 py-1 v-for="(key, kk) in nKeys" :key="kk+'-kkeyy'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="key" xs6 md6>
                            <div class="caption grey--text ">Key / Document Number</div>
                            <v-tooltip top>
                              <span slot="activator">{{ key }}</span>
                              <span>{{ key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex xs12 xs6 md6>
                            <v-btn 
                              v-clipboard:copy="key"
                              v-clipboard:success="clipboardSuccessHandler"
                              v-clipboard:error="clipboardErrorHandler"
                              flat small color="primary">copy</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Updated Leads {{ dleads.length }} / {{ totalW - nKeys.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(dleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="dleads && dleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in dleads" :key="l+'-dlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Failed Warehouseh Transactions {{ ftleads.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(ftleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="ftleads && ftleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in ftleads" :key="l+'-ftlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.phone_number_1" xs6 md2>
                            <div class="caption grey--text ">Phone</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.phone_number_1"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >{{ lead.phone_number_1 }}
                              </span>
                              <span>{{ lead.phone_number_1 }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order_status" xs6 md2>
                            <div class="caption grey--text ">Order Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.order_status }}</span>
                              <span>{{ lead.order_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.key" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.key"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.key }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.document_number" xs6 md1>
                            <div class="caption grey--text ">Doc</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.document_number"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.document_number }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.shipping_status" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.shipping_status | truncate(15, (lead.shipping_status.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.shipping_status }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.order" xs6 md2>
                            <div class="caption grey--text ">Items</div>
                            <v-layout row wrap>
                              <v-flex xs12 v-for="(tt, jj) in lead.order" :key="jj+'-iteminorder'">
                                <v-tooltip top>
                                  <span slot="activator"
                                    v-clipboard:copy="tt.sku"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                  >
                                    {{tt.sku}}
                                  </span>
                                  <span>{{ tt.sku }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex v-if="lead.done" xs6 md1>
                            <div class="caption grey--text ">Done</div>
                            <v-tooltip top>
                              <span slot="activator">
                                <v-avatar
                                  size="15"
                                  color="success"
                                >
                                  <v-icon>done_all</v-icon>
                                </v-avatar>
                              </span>
                              <span>done</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center" style="font-weight:bold;">
                  Failed SKU Transactions on Orders {{ fttleads.length }}
                </v-flex>
                <v-flex xs12 py-3 px-1 style="background:#efefef;max-height:600px;overflow-y:scroll;">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-btn color="success" small @click="exportData(fttleads)">export</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="fttleads && fttleads.length">
                    <v-flex xs12 py-1 v-for="(lead, l) in fttleads" :key="l+'-ftlead'">
                      <v-card>
                        <v-layout row wrap pa-2>
                          <v-flex v-if="lead.order" xs6 md1>
                            <div class="caption grey--text ">Key</div>
                            <v-tooltip top>
                              <span slot="activator"
                                v-clipboard:copy="lead.order"
                                v-clipboard:success="clipboardSuccessHandler"
                                v-clipboard:error="clipboardErrorHandler"
                              >
                                copy
                              </span>
                              <span>{{ lead.order }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="lead.sku" xs6 md2>
                            <div class="caption grey--text ">Shipping Status</div>
                            <v-tooltip top>
                              <span slot="activator">{{ lead.sku | truncate(15, (lead.sku.length>15 ? '..': '')) }}</span>
                              <span>{{ lead.sku }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 py-3>
                  <v-layout row wrap>
                    <v-flex xs6 pa-1>
                      <v-menu
                        v-model="fsd"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template slot="activator">
                          <v-text-field
                            v-model="fTLDate"
                            label="From Status Date"
                            append-icon="event"
                            readonly
                            :disabled="loading"
                            hide-details
                            clearable
                            solo
                            :loading="loading"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-autocomplete
                        label="Shipping Status"
                        :items="shippingStatus"
                        v-model="newShippingStatus"
                        solo
                        :disabled="loading"
                        hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-select
                        hide-details
                        :items="warehouses.filter(x=>!x.lock)"
                        solo
                        :disabled="loading"
                        :loading="loading"
                        item-value="name"
                        v-model="selectedWarehouse"
                        label="Warehouse"
                        item-text="name"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 pa-1>
                      <v-text-field
                        v-model="userName"
                        disabled
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
							<v-btn @click="updateNewByKey()" v-if="false" :disabled="loading" :loading="loading" color="success" dark>
                update new data keys with values
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-select
                :items="['key', 'document_number']"
                v-model="searchBy"
                label="Fetch By"
                :loading="loading"
                :disabled="loading"
              ></v-select>
              <v-btn @click="backUpdate()" :loading="loading" :disabled="loading" color="success" >
                update on backend
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
import json2csv from 'json2csv'
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  data(){
    return {
			loading: false,
      pastedData:null,
      spastedData:null,
      delimiter:',',
      fttleads:[],
      pKeys:[],
      leads:[],
      dleads:[],
      ftleads:[],
      nKeys:[],
      eleads:[],
      totalW:0,
      totalK:0,
      dArray:[],
      oArray:[],
      nArray:[],
      mArray:[],
      eArray:[],
      newShippingStatus:null,
      shippingStatus:[],
      fsd:null,
      fTLDate:null,
      warehouses:[],
      selectedWarehouse:null,
      products:[],
      searchBy:null,
    }
  },
  methods: {
    async getShippingStatuses(){
      let a = await db.ref('shippingstatuses').once('value').then(x=>x.val())
      this.shippingStatus = Object.values(a).map(x=>x.name)
      console.log(a)
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          key:y.id
        }
      }).filter(x=>!x.lock))
      console.log(this.warehouses)
      this.loading = false
    },
    async getProducts(){
      this.loading = true
      this.products = await store.collection('products').get()
      .then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          warehouses:y.data().warehouses? y.data().warehouses:[]
        }
      }))
      this.loading = false
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    async searchByKey(){
      this.leads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          key: x.trim()
        } 
      });
      this.totalW = a.length;
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          if(!this.leads.map(x=>x.key).includes(r.key)) {
            let l = await store.collection('leads').doc(r.key).get().then(x=>x.data())
            if(l){
              if(!l.key) l.key = r.key
              this.leads.push(l)
              this.eleads.push(l)
            } else {
              this.nKeys.push(r.key)
            }
          }
        }
        console.log(this.leads)
      })()
    },
    async searchByDoc(){
      this.leads = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>{
        return {
          document_number: x.trim()
        } 
      });
      this.totalW = a.length;
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          if(!this.leads.map(x=>x.document_number).includes(r.document_number)){
              let l = await store.collection('leads').where('document_number', '==', r.document_number).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}))
            if(l && l[0]) {
              this.leads.push(l[0])
              this.eleads.push(l[0])
            } else {
              this.nKeys.push(r.document_number)
            }
          }
        }
        console.log(this.leads)
      })()
    },
    async updateKeysWithDocN() {
      this.dArray =[]
      this.nArray =[]
      this.mArray =[]
      this.oArray =[]
      this.eArray =[]

      let a = this.getArray();
      this.totalK = a.length;
			(async () => {
				for (let i = 0; i < a.length; i++) {
					const lead = a[i];
					if(lead.key){
            let k = lead.key
            let sL = await store.collection(`leads`).doc(k).get().then(x=>x.data())
            if(sL && sL.document_number) {
              this.oArray.push(lead.key)
            } else {
              try {
                await store.collection(`leads`).doc(k).update({document_number:lead.document_number, customer_id:lead.customer_id})
                this.dArray.push(lead.key)
              } catch (error) {
                this.nArray.push(lead.key)
                let o = await db.ref(`leads/${k}`).once('value').then(x=>x.val())
                if(o) {
                  o.key = k
                  o.document_number = lead.document_number
                  o.customer_id = lead.customer_id
                  await store.collection(`leads`).doc(k).set(o)
                  let c = await store.collection(`leads`).doc(k).get().then(x=>x.data)
                  if(c) {
                    await db.ref(`leads`).update({[k]:null})
                    this.mArray.push(lead.key)
                  }
                } else {
                  this.eArray.push(lead.key)
                }
              }
            }
					}
				}
			})()
    },
		updateByKey(){
      this.pKeys=[]
      this.nKeys=[]
			let a = this.getArray();
			(async () => {
				for (let i = 0; i < a.length; i++) {
					const order = a[i];
					if(order.key){
						let n = order
						let k = order.key
						this.pKeys.push(order.key)
						delete n.key
						await db.ref(`leads/${k}`).update(n)
						console.log(order.key)
					}
				}
			})()
    },
    allowTransaction(lead, status, transType){
      console.log(lead)
      console.log(status)
      console.log(transType)
      let trans = ['add', 'subtract'];
      lead.shipping_status =  lead.shipping_status ? lead.shipping_status.split(' ').join('_').toLowerCase() : null
      if (!lead.last_transaction && status != 'returned') {
        return true
      } else if (lead.last_transaction) {
        if (lead.last_transaction == "subtract" && lead.shipping_status == 'out_for_delivery') {
          let allow = ['delivered', 'returned', 'unpacked', 'under_return_process']
          if (allow.includes(status)) {
            return true
          } else {
            return false
          }
        } else if (lead.last_transaction == "add" && lead.shipping_status == 'returned') {
          let allow = ['out_for_delivery', 'pending', 'hurt']
          if (allow.includes(status)) {
            return true
          } else {
            return false
          }
        } else if (lead.last_transaction == "none" && lead.shipping_status == 'under_return_process') {
          let allow = ['returned']
          if (allow.includes(status)) {
            return true
          } else {
            return false
          }
        } else if(trans.includes(transType[status]) && lead.shipping_status != 'returned' && lead.shipping_status != 'out_for_delivery') {
          if(lead.last_transaction != transType[status] && status != 'returned') {
            return true
          } else if( lead.last_transaction != transType[status] && status == 'returned' && lead.shipping_status == 'out_for_delivery') {
            return true
          }
        } else if(!trans.includes(transType[status]) && lead.shipping_status != 'returned' && lead.shipping_status != 'out_for_delivery') {
          return true
        }
      }
    },
    checkTransactions(lead, warehouse, products){
      let l = lead.order.length;
      let o = lead.order
      let c = []
      for (let i = 0; i < o.length; i++) {
        const item = o[i];
        let isku = item.sku.replace(/\u21b5/g,'').replace('↵', '').trim()
        let p = products.filter(x=>x.sku == isku)[0]
        if(p && p.warehouses && p.warehouses.length && p.warehouses.filter(x=>x.warehouse == warehouse)[0]) {
          c.push(true)
        }
      }
      if(c.length == l) {
        return true
      } else {
        return false
      }
    },
    allowedDate(order, dateSetting) {
      let a = order.import_date
      let b = new Date(a).getTime()
      let c = dateSetting
      if(b >= c) {
        return true
      } else {
        if(this.$props.superAdmin) {
          return true
        } else {
          return false
        }
      }
    },
    async updateNewByKey() {
      if(!this.newShippingStatus || !this.fTLDate || !this.selectedWarehouse){
        this.$emit('snackbarNotification', `Input missing`, 'error')
        return false
      }
      console.log('moataz!')
			this.pKeys=[]
      this.fKeys=[]
      this.nKeys=[]
      let dateSetting = await db.ref(`settings/lockdate`).once('value').then(x=>x.val());
      let status = this.newShippingStatus.split(' ').join('_').toLowerCase()
      let statusSetup = await db.ref('settings/shippingstatuses').once('value').then(x=>x.val())
			let a = this.leads;
			(async () => {
				for (let i = 0; i < this.leads.length; i++) {
          const order = this.leads[i];
          let transaction_id = randomString(8, '#Aa')
				  let transaction_timestamp = new Date().getTime()
          let lback = {...this.leads[i]}
					if(order.key && this.allowedDate(order, dateSetting)){
						let n = order
						let k = this.leads[i].key
						this.pKeys.push(this.leads[i].key)
						try {
              if(this.allowTransaction(lback, status, statusSetup) && this.checkTransactions(lback, this.selectedWarehouse, this.products)){
                this.leads[i].shipping_status = this.newShippingStatus
                if(status){
                  if(!this.leads[i].shipping_status_timeline){
                    this.leads[i].shipping_status_timeline = {}
                  }
                  if(!this.leads[i].shipping_status_timeline[status]) {
                    this.leads[i].shipping_status_timeline[status] = {}
                  }
                  this.leads[i].shipping_status_timeline[status]['date'] = this.fTLDate
                  this.leads[i].shipping_status_timeline[status]['change_date'] = getCDate()
                  this.leads[i].shipping_status_timeline[status]['agent'] = this.$props.userName
                  this.leads[i].shipping_status_timeline[status]['key'] = status
                }
                if(statusSetup[status] == 'none') {
                  this.leads[i].last_transaction = 'none'
                }
                console.log(n)
                
                  this.leads[i].reserved = false
                  this.leads[i].reserved_wh = false

                let bb = await db.ref('uKeys').push()
                if(!order.shipping_timeline) order.shipping_timeline = {}
                order.shipping_timeline[bb.key] = {
                  status:status,
                  agent:this.$props.userName,
                  date:getCDate()
                }
                await db.ref('uKeys').update({
                  [bb.key]:null
                })
                await store.collection(`leads`).doc(k).update(this.leads[i]);
              } else {
                this.ftleads.push(this.leads[i])
              }
              let trans = ['add', 'subtract'];
              for (let o = 0; o < this.leads[i].order.length; o++) {
                const item = this.leads[i].order[o];
                console.log('item sku corrected', item.sku)
                console.log(this.products.filter(x=>x.sku == item.sku))
                let p = this.products.filter(x=>x.sku == item.sku.replace(/\u21b5/g,'').replace('↵', '').trim())[0]
                console.log('filtered products', p)
                if( statusSetup[status] 
                    && this.selectedWarehouse
                    && this.checkTransactions(lback, this.selectedWarehouse, this.products)
                    && (this.allowTransaction(lback, status, statusSetup))
                    && p
                    && p.warehouses
                    && p.warehouses.length 
                    && p.warehouses.filter(x=>x.warehouse == this.selectedWarehouse)[0]) {
                  console.log('passed check')
                  let a = await store.collection('products').where('sku', '==', item.sku.replace(/\u21b5/g,'').replace('↵', '').trim()).get().then(x=>x.docs[0].data())
                  console.log('fetched products', a)
                  let sWH = this.selectedWarehouse
                  
                  if(statusSetup[status] == 'add') {
                    let oV = parseInt(a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity)
                    console.log(oV)
                    a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity = oV + parseInt(item.quantity)
                    console.log('after adding')
                    console.log(a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity)
                    var sfDocRef = store.collection("products").doc(a.key);
                    await store.runTransaction(function(transaction) {
                      // This code may get re-run multiple times if there are conflicts.
                      return transaction.get(sfDocRef).then(function(sfDoc) {
                          if (!sfDoc.exists) {
                              throw "Document does not exist!";
                          }
                          // Add one person to the city population.
                          // Note: this could be done without a transaction
                          //       by updating the population using FieldValue.increment()
                          var product = sfDoc.data()
                          product.warehouses.filter(x=>x.warehouse == sWH)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == sWH)[0].quantity) + parseInt(item.quantity);
                          transaction.update(sfDocRef, product);
                      });
                    })
                    this.leads[i].last_transaction = 'add'
                  } else if (statusSetup[status] == 'subtract') {
                    let oV = parseInt(a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity)
                    console.log(oV)
                    a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity = oV - parseInt(item.quantity)
                    console.log('after subtracting')
                    console.log(a.warehouses.filter(x=>x.warehouse == sWH)[0].quantity)
                    var sfDocRef = store.collection("products").doc(a.key);
                    await store.runTransaction(function(transaction) {
                      // This code may get re-run multiple times if there are conflicts.
                      return transaction.get(sfDocRef).then(function(sfDoc) {
                          if (!sfDoc.exists) {
                              throw "Document does not exist!";
                          }
                          // Add one person to the city population.
                          // Note: this could be done without a transaction
                          //       by updating the population using FieldValue.increment()
                          var product = sfDoc.data()
                          product.warehouses.filter(x=>x.warehouse == sWH)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == sWH)[0].quantity) - parseInt(item.quantity);
                          transaction.update(sfDocRef, product);
                      });
                    })
                    this.leads[i].last_transaction = 'subtract'
                  } else {
                    this.leads[i].last_transaction = 'none'
                  }
                  console.log('product update', a)
                  try {
                    // await store.collection('products').doc(a.key).update(a)
                    
                  } catch (error) {
                    console.log(error)
                  }
                  console.log('transaction', {
                    product_sku:p.sku.trim(),
                    product_key:p.key,
                    user:this.$props.userName,
                    date:getCDate(),
                    status:status,
                    transaction_timestamp,
                    transaction_id,
                    status_date:this.fTLDate,
                    timestamp:new Date(getCDate()).getTime(),
                    quantity:parseInt(item.quantity),
                    transaction:statusSetup[status],
                    warehouse_name:this.selectedWarehouse,
                    warehouseh_key:this.warehouses.filter(x=>x.name == this.selectedWarehouse)[0].key,
                    order_key:this.leads[i].key,
                    document_number: this.leads[i].document_number ? this.leads[i].document_number : 0
                  })
                  await store.collection('warehouseactions').add({
                    product_sku:p.sku.trim(),
                    product_key:p.key,
                    user:this.$props.userName,
                    date:getCDate(),
                    status:status,
                    transaction_timestamp,
                    transaction_id,
                    status_date:this.fTLDate,
                    timestamp:new Date(getCDate()).getTime(),
                    quantity:parseInt(item.quantity),
                    transaction:statusSetup[status],
                    warehouse_name:this.selectedWarehouse,
                    warehouseh_key:this.warehouses.filter(x=>x.name == this.selectedWarehouse)[0].key,
                    order_key:this.leads[i].key,
                    document_number: this.leads[i].document_number ? this.leads[i].document_number : 0
                  })
                  await sleep(500)
                } else {
                  console.log('failed  sku', item.sku)
                  this.ftleads.push(this.leads[i])
                }
              }
              
              await store.collection(`leads`).doc(k).update(this.leads[i]);
              this.leads[i].done = true
              this.dleads.push(this.leads[i])
						} catch (error) {
              this.nKeys.push(this.leads[i].key)
              console.log(error)
						}
					} else {
            this.nKeys.push(this.leads[i].key)
          }
				}
				console.log('failed keys', this.fKeys)
			})()
    },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)
          return array.map(it => {
            return Object.values(it).toString()
          }).join('\n')
    },
    pivot(arr) {
        var mp = new Map();
        
        function setValue(a, path, val) {
            if (Object(val) !== val) { // primitive value
                var pathStr = path.join('.');
                var i = (mp.has(pathStr) ? mp : mp.set(pathStr, mp.size)).get(pathStr);
                a[i] = val;
            } else {
                for (var key in val) {
                    setValue(a, key == '0' ? path : path.concat(key), val[key]);
                }
            }
            return a;
        }
        
        var result = arr.map( obj => setValue([], [], obj) );
        return [[...mp.keys()], ...result];
    },
    toCsv(arr) {
        return arr.map( row => 
            row.map ( val => isNaN(val) ? JSON.stringify(val) : +val ).join(',')
        ).join('\n');
    },
    exporLeadsByKey(){
      let leads = [...this.eleads]
      console.log('------------------------------------');
      console.log(leads);
      console.log('------------------------------------');
      let exportArray = []
      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          const lead = leads[key];
          console.log('------------------------------------', lead);

          let k = lead.status_timeline ? Object.keys(lead.status_timeline) : null
          let lastcdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i)=>{return {...x, key:k[i]}})
          .filter(x => x.key == 'dispatch')
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null
          let Sdates = {}
          let kShip = lead.shipping_status_timeline ? Object.keys(lead.shipping_status_timeline) : null
          let lastSdate = lead.shipping_status_timeline ? Object.values(lead.shipping_status_timeline)
          .forEach((x, i)=>{ Sdates[kShip[i]] = x.date }) : []

          if (lead.order) {
            let order = lead.order
            for (let i = 0; i < order.length; i++) {
              const item = order[i];
              //delete lead.order
              exportArray.push({
                ...lead,
                item_name: item.product,
                item_sku: item.sku,
                item_unite_price: item.baseprice,
                item_quantity: item.quantity,
                last_dispatch_date: lastcdate ? lastcdate.date : null,
                last_dispatch_agent: lastcdate ? lastcdate.agent : null,
                ...Sdates
              })
            }
          }
        }
      }
      console.log('------------------------------------');
      console.log(exportArray);
      console.log('------------------------------------');
      //let a = this.toCsv(this.pivot(exportArray))
      let a = json2csv.parse(exportArray)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `leads_export.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    exportData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'leads_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async onlyMe(){
      console.log('started')
      // let b = [
      //   '21651721825',
      //   '9626000456',
      //   '96262000045',
      //   '962620000471',
      //   '96262000458',
      //   '96262000460',
      //   '96262000471',
      //   '96262008683',
      //   '962785219523',
      //   '962796041616',
      //   '962796939247',
      //   '9647806233331',
      //   '966502889860',
      //   '966503004443',
      //   '966503548667',
        
      //   '97339930966',
      //   'bulk',
      //   'NaN',
      //   'numbers',
      //   'undefined',
      // ];
      // (async x=>{
      //   for (let i = 0; i < b.length; i++) {
      //     const k = b[i];
      //     console.log(k)
      //     await db.ref(`whatsapp`).update({[k]:null})
      //   }
      // })()
      // let sender = 'sie99iL40Y'
      // let startDate = new Date().getTime() - parseInt(60) * 24 * 60 * 60 * 1000
      // let a = await db.ref(`whatsapp/96262000040`)
      //   .orderByChild('last_message')
      //   .startAt(startDate)
      //   .once('value').then(x=>x.val())
      // let msgs = Object.values(a).map(x=>x.messages)
      // let convos = Object.values(a).map(x=>{
      //   let {
      //     last_message,
      //     need,
      //     number,
      //     status,
      //     } = x
      //   return {
      //     last_message,
      //     need,
      //     number,
      //     sender_key: 'sie99iL40Y',
      //     status,
      //     platform: 'default',
      //     country: 'ASHYAAT GULF'
      //   }
      // });
      // (async x=>{
      //   for (let i = 0; i < convos.length; i++) {
      //     const con = convos[i];
      //     let b = await store.collection('waconversations').add(con);
      //     console.log('convo', `${i+1} of ${convos.length+1}`)
      //     let cmsgs = Object.values(msgs[i]);
      //     (async y=>{
      //       for (let k = 0; k < cmsgs.length; k++) {
      //         const msg = cmsgs[k];
      //         await store.collection('waconversations').doc(b.id).collection('messages').add(msg)
      //         console.log('msg', `${k+1} of ${cmsgs.length+1}`)
      //       }
      //     })()
      //     await db.ref(`whatsapp/96262000040`).update({[con.number]:null})
      //   }
      //   console.log('done')
      // })()
    },
    async backUpdate(){
      this.loading = true
      if(!this.newShippingStatus || !this.fTLDate || !this.selectedWarehouse || !this.searchBy){
        this.$emit('snackbarNotification', `Input missing`, 'error')
        return false
      }
      let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
      let exportLeads = [];
      let beforeLeads = [];
      let limit = 200
      let numNeeded = a.length / limit
      let loops = a.length % limit == 0 ? a.length / limit : parseInt(a.length / limit) + 1;
      
      (async x=>{
        for (let i = 0; i < loops + 1; i++) {
          await sleep(15000)
          let data = {
            keys:a.slice(i*limit, i*limit+limit),
            newShippingStatus:this.newShippingStatus,
            userName:this.$props.userName,
            fTLDate:this.fTLDate,
            selectedWarehouse:this.selectedWarehouse,
            searchBy:this.searchBy
          }
          console.log(data)
          let m = await axios.post(`https://us-central1-ashyaatcrm.cloudfunctions.net/shippingupdate/shippingUpdate`, data, headers).then(x=>x.data)
          console.log(m)
          this.nKeys = [...this.nKeys, ...m.notfound]
          this.dleads = [...this.dleads, ...m.leads_with_changed_status]
          this.ftleads = [...this.ftleads, ...m.leads_with_failed_transaction]
          this.fttleads = [...this.fttleads, ...m.failed_sku]
          exportLeads = [...exportLeads, ...m.leads]
          beforeLeads = [...beforeLeads, ...m.before_edit_leads]
        }
        this.exportData(beforeLeads, 'Before_edit_leads')
        this.exportData(exportLeads, 'Ready_leads_export')
        this.loading = false
      })()
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
		beta:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
    
    this.getShippingStatuses()
    // this.getProducts()
    this.getWarehouses()
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
